<template>
  <div class="content">
    <div class="content-top">
      <el-button-group class="button-group">
        <PageButton :groupName="'文档'" v-on="{ loadData, upLoad, createFolder }"></PageButton>
      </el-button-group>
    </div>
    <div class="content-bottom">
      <div class="content-aside">
        <auth-dept-tree :width="treeWidth" @setTreeWidth="setTreeWidth" @nodeClick="nodeClick"></auth-dept-tree>
      </div>
      <div class="content-content">
        <document-mange
          :buttons="buttons"
          @queryRoot="queryRoot"
          ref="documentMange"
          :data="documentData"
          @menuClick="menuClick"
        ></document-mange>
      </div>
    </div>
    <lr-dialog
      :dialogTitle="attachDialogTitle"
      :dialogVisible.sync="attachDialogVisible"
      :destroyOnClose="true"
      :closeSubmit="true"
    >
      <lr-crud
        ref="attachBtnCrud"
        :tableData="attachTableData"
        :options="attachOptions"
      >
        <template #FileSize="row">{{
          converMethod(row.data.FileSize)
        }}</template>
        <template #headerBtnLeft
          >
          <template v-for="(item,index) in attachButtons" >
            <el-button
              :key="index"
              v-if="item.ActionFlag==='upLoad'&&userInfo.UserID===rightCurrent.CreatorID&&(rightCurrent.AuditedStatus===1||rightCurrent.AuditedStatus===0||rightCurrent.AuditedStatus===3)"
              type="primary"
              size="small"
              @click="upLoad(true)"
              class="icon icon-shangchuan"
              >上传附件</el-button
            >
            </template>
        </template>
        <template #menuAction="row">
          <template v-for="(item,index) in attachButtons" >
            <el-button
               v-if="item.ActionFlag==='viewAttach'"
              :key="index"
              plain
              type="success"
              @click="viewAttach(row.data)"
              size="mini"
              >预览附件</el-button
            >
            <el-button
               v-if="item.ActionFlag==='downloadAttach'"
              :key="index"
              plain
              type="primary"
              @click="downloadAttach(row.data)"
              size="mini"
              >下载附件</el-button
            >
            <el-button
            :key="index"
             v-else-if="item.ActionFlag==='deleteAttach'&&userInfo.UserID===rightCurrent.CreatorID&&(rightCurrent.AuditedStatus===1||rightCurrent.AuditedStatus===0||rightCurrent.AuditedStatus===3)"
              plain
              type="danger"
              @click="deleteAttach(row.data)"
              size="mini"
              >删除附件</el-button
            >
          </template>
          
        </template>
      </lr-crud>
    </lr-dialog>
    <lr-dialog
      :dialogTitle="operationsDialogTitle+'操作记录'"
      :dialogVisible.sync="operationsDialogVisible"
      :destroyOnClose="true"
      :closeSubmit="true"
      :width="'500px'"
    >
      <lr-crud
        ref="operationsBtnCrud"
        :tableData="operationsTableData"
        :options="operationsOptions"
        :summaryMethod="summaryMethod"
      >
        <template #Name>{{ rightCurrent.Name }}</template>
      </lr-crud>
    </lr-dialog>
    <lr-dialog
      :dialogTitle="dialogTitle"
      :dialogVisible.sync="dialogVisible"
      @diaLogSubmit="diaLogSubmit"
      :width="'400px'"
      :destroyOnClose="true"
    >
      <div class="dialog-content">
        <lr-form
          :form="formData"
          :ref="bindRef"
          :bindRef="bindRef"
          :rules="rules"
          :column="column"
          :closeDestroy="false"
        >
        </lr-form>
        <el-button
          v-if="this.formData.FileExt"
          type="primary"
          size="mini"
          @click="upLoad(false, 'again')"
          class="icon icon-shangchuan uploadAgain"
          >重新上传</el-button
        >
      </div>
    </lr-dialog>
    <lr-dialog
      :dialogTitle="'选择共享目标'"
      :dialogVisible.sync="shareDialogVisible"
      :width="'400px'"
      :footerSlot="true"
      :destroyOnClose="true"
    >
      <template #footer>
        <el-button
        type="warning"
        size="mini"
        class="icon icon-fenxiang"
        @click="documentShareAddPublicFun"
        >设为公共文档</el-button>
        <el-button
        type="primary"
        size="mini"
        class="icon icon-jigou"
        @click="shareDept"
        >部门</el-button>
        <el-button
        type="success"
        size="mini"
        class="icon icon-jiaose"
        @click="shareUser"
        >人员</el-button>

      </template>
    </lr-dialog>
    <div>
      <!-- @closeCallback="uploadCloseCallback" -->
      <lr-upload
        @uploadSuccess="uploadSuccess"
        @uploadError="uploadError"
        v-if="uploadVisiable"
        :uploadVisiable.sync="uploadVisiable"
        :bindRef="fileUpload"
        :ref="fileUpload"
        :options="options"
      ></lr-upload>
      <add-users
        ref="addRoles"
        v-if="addRolesDialogVisible"
        @submit="addRolesSubmit"
        :currentWebSiteID="currentWebsiteId"
        @closeCallback="addRolesCloseCallback"
      ></add-users>
      <add-depts
        ref="AddDepts"
        v-if="addDeptsDialogVisible"
        @submit="addDeptsSubmit"
         :currentWebSiteID="currentWebsiteId"
        @closeCallback="addDeptsCloseCallback"
      ></add-depts>
      <add-users
        ref="addRole"
        v-if="addRoleDialogVisible"
        @submit="addRoleSubmit"
        :multiple="false"
        :currentWebSiteID="currentWebsiteId"
        @closeCallback="addRoleCloseCallback"
      ></add-users>
    </div>
  </div>
</template>

<script>
import {IsPub,Operation} from "@/areas/systemmanage/config/localDictionary";
import SelfDeptTree from "@/components/LrOrganization/SelfDeptTree";
import AddUsers from '@/areas/systemmanage/views/user/components/AddUsers'
import AddDepts from './components/AddDepts'
import DocumentMange from "./components/DocumentMange";
import { documentFolderTree,documentFolderAdd,documentFirstlevellist,documentFolderEdit,documentFolderDelete,documentFolderChildren,documentDelete,documentEdit,documentShareAdd,documentShareDelete,documentShareList,documentAttachDelete,documentOperations,documentDownload,documentAudit,documentToaudit,documentView,documentAuditRecord } from "@/api/document.js";
import store from '@/store'
import {conver,getQueryParam} from '@/utils/index'
export default {
  name: "tree",
  components: {
    SelfDeptTree,
    DocumentMange,
    AddUsers,
    AddDepts
  },
  mounted() {
    this.userInfo = store.state.user.userInfo
    this.currentWebsiteId =  this.userInfo.WebSiteID
    store.state.permission.authButtons.map((item,index)=>{
      if(item.MenuType==3){
        this.buttons.push(item)
      }
      if(item.GroupName=='附件'){
        this.attachButtons.push(item)
      }
    })
    this.documentFolderTreeFun();
  },
  computed: {
    options(){
      let options ={
          //url:'/api/document/upload',
          width:'500px',
          moduleId:store.state.permission.moduleID,
          token:store.getters.token,
          formData:{category:this.category,auditstatus:this.auditedStatus,folderid:this.current.ID}
       }
      if(this.isAttach){
        options.url = '/api/document/attach/upload'
        options.formData.docid = this.rightCurrent.ID
      }else{
        options.url = '/api/document/upload'
      }
      
      return options
    },
    column() {
      let column = [];
      if(!this.formData.FileExt){//文件夹
        column =[{label: "上级目录",field: "ParentID",span: 24,type: "selectTree",options: [],default: "",props: { value: "id", label: "label", children: "children" }, },
        { label: "文件夹名", field: "Name", span: 24 },
        //{ label: "是否公用", field: "IsPub", span: 24,options:IsPub ,type: "radio",default:'N'},
        //{label: "排序字段",field: "Sort",span: 24,default:1,type:'number'},
        ]
      }else{//其他文件
        column =[{label: "上级目录",field: "ParentID",span: 24,type: "selectTree",options: [],default: "",props: { value: "id", label: "label", children: "children" }, },
        { label: "文件名", field: "Name", span: 24 },
        ]
      }
      this.$set(column[0], "options", this.parentData);
      return column
    }
  },
  data() {
    return {
      currentWebsiteId:'',
      viewTypes:['.doc','.docx','.htm','.txt','.xps','.pdf','.dot','.csv','.xls','.xlsx','.xltx','.xlt','.ppt','.pptx'],
      attachButtons:[],
      buttons:[],
      addRoleDialogVisible:false,
      addRolesDialogVisible:false,
      addDeptsDialogVisible:false,
      rightCurrent:{},
      attachDialogTitle:'附件列表',
      attachDialogVisible:false,
      attachTableData:[],
      attachOptions:{
        queryBtn:false,
        column: [
          { label: "附件名称", field: "Name"},
          { label: "附件类型", field: "FileExt"},
          { label: "附件大小", field: "FileSize",slot:true,},
        ],
        height: "300",
        pagination: false,
        menuBtn:true,
        menuBtnWidth:'300'
      },
      operationsDialogTitle:'文档操作记录',
      operationsDialogVisible:false,
      operationsTableData:[],
      operationsOptions:{
        loading:true,
        queryBtn:false,
        column: [
            { label: "更新人姓名", field: "UpdaterName"},
            { label: "更新时间", field: "UpdateTime"},
            { label: "操作", field: "Operation",type:'select',options:Operation},
            ],
        height: "300",
        showSummary:true,
        pagination: false,
      },
      userInfo :{},
      uploadVisiable:false,
      fileUpload:'fileUpload',
      hideRules: ["add", "update", "del"],
      param: "",
      dialogTitle: "添加文件夹",
      dialogVisible: false,
      formData: {},
      bindRef: "form",
      rules: {
        Name: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
      },
      category:getQueryParam( window.location.href,'Category'),
      auditedStatus:getQueryParam( window.location.href,'AuditedStatus')=='Y'?1:0,
      parentData: [],
      documentData:[],
      current:{},
      isAttach:false,
      treeWidth:'200px',
      shareDialogVisible:false,
    };
  },
  methods:  {
    viewAttach(item){
      item.isattach = 1;
      if(item.FileExt=='.png'||item.FileExt=='.jpg'||item.FileExt=='.gif'||item.FileExt=='.jpeg'){
        this.documentDownloadFun(item,'view')
      }else if(item.FileExt=='.lfm'||item.FileExt=='.lfmx'||item.FileExt=='.dwg'){
        this.$errorMessage('此文件不支持在线预览，请下载查看');
      }else if(this.viewTypes.includes(item.FileExt)){
        this.documentViewFun(item)
      }else {
          this.$errorMessage('此文件不支持在线预览，请下载查看');
      }
    },
    converMethod(data){
      return conver(data)
    },
    summaryMethod(param){
       const { columns, data } = param;
        const sums = [];
        let downSums = 0;
        let viewSums = 0;
        data.forEach((item, index) => {
          if(item.Operation===2)    {
            downSums++
          }else if(item.Operation===1){
            viewSums++
          }      
        });
        sums[0]='下载：'+downSums+'次'
        sums[1]='在线预览：'+viewSums+'次'
        sums[2]='操作合计：'+data.length+'次'
        return sums;
    },
    addDeptsCloseCallback(){
      this.addDeptsDialogVisible = false;
    },
    addDeptsSubmit(data){
      if(data.length==0){
        this.$errorMessage('请选择部门');
        return false
      }
        this.documentShareAddFun('depts',data)
    },
    addRoleCloseCallback(){
      console.log(1)
      this.addRoleDialogVisible = false;
    },
    addRolesCloseCallback(){
      this.addRolesDialogVisible = false;
    },
    addRoleSubmit(data){
      if(data.length==0){
        this.$errorMessage('请选择审核人');
        return false
      }
      this.$prompt('请输入送审说明', '提示', {
          confirmButtonText: '提交',
          cancelButtonText: '取消',
          closeOnClickModal:false,
          inputType:'textarea',
        }).then(({ value }) => {
          documentToaudit({DocID:this.rightCurrent.ID,NextAuditedPersonID:data[0].ID,NextAuditedPersonName:data[0].DisplayName,Remark:value}).then((res) => {
            if (res.Code === 200) {
              this.$successMessage(res.Message);
              this.refsh()
              this.addRoleDialogVisible = false;
            }
          });
        }).catch(() => {
        });
      
    },
    addRolesSubmit(data){
      if(data.length==0){
        this.$errorMessage('请选择人员');
        return false
      }
      this.documentShareAddFun('roles',data)
    },
    shareList(){
      this.shareDialogVisible=true;
      this.$nextTick(()=>{
        documentShareList().then((res) => {
            if (res.Code === 200) {
              this.shareTableData = res.Data
            }
        });
      })
    },
    refsh(){
      if(this.current.ID){
        this.documentFolderChildrenFun(this.current)
      }else{
        this.documentFirstlevellistFun()
      }
    },
    uploadError(object,ret){
      console.log(object,ret)
    },
    uploadSuccess(object,ret){
      this.formData.Name = ret.Data.Name
      this.refsh()
    },
    queryRoot(id){
      if(id){
        this.documentFolderChildrenFun({ID:id})
      }else{
        this.documentFirstlevellistFun()
      }
      
    },
    menuClick(item,btn){
      btn.Type = btn.ActionFlag
      if(btn.Type){
          this.rightCurrent =item;
          if(btn.Type==='edit'){
            this.formData = JSON.parse(JSON.stringify(item));
            this.dialogVisible=true;
            this.dialogTitle = this.formData.FileExt?'编辑文档':'编辑文件夹'
            this.$nextTick(()=>{
              this.documentFolderTreeFun();
            })
          }else if(btn.Type==='delete'){
            if(!item.FileExt){//文件夹删除
              this.documentFolderDeleteFun(item);
            }else{//其他文件
              this.documentDeleteFun(item);
            }     
          }else if(btn.Type==='view'){
            if(item.Type==1){
              this.documentFolderChildrenFun(item)
            }else{
              item.isattach = 0;
              if(item.FileExt=='.png'||item.FileExt=='.jpg'||item.FileExt=='.gif'||item.FileExt=='.jpeg'){
                this.documentDownloadFun(item,'view')
              }else if(item.FileExt=='.lfm'||item.FileExt=='.lfmx'||item.FileExt=='.dwg'){
                this.$errorMessage('此文件不支持在线预览，请下载查看');
              }else if(this.viewTypes.includes(item.FileExt)){
                this.documentViewFun(item)
              }else {
                 this.$errorMessage('此文件不支持在线预览，请下载查看');
              }
              
            }
          }else if(btn.Type==='share'){
            this.shareDialogVisible=true
            // this.$confirm('选择共享部门或人员', '提示', {
            //   confirmButtonText: '人员',
            //   cancelButtonText: '部门',
            //   showClose:false,
            //   type: 'warning'
            // }).then((res) => {
            //    this.addRolesDialogVisible=true;
            // }).catch((res) => {
            //    this.addDeptsDialogVisible=true;       
            // });
            //this.documentShareAddFun(item)
          }else if(btn.Type==='deleteShare'){
            this.documentShareDeleteFun(item)
          }else if(btn.Type==='attachUpload'){
            this.upLoad(true)
          }else if(btn.Type==='attachView'){
            this.attachDialogVisible = true;
            this.$nextTick(()=>{
              this.attachTableData =item.AttachList?item.AttachList:[];
            })
          }else if(btn.Type==='operations'){
            if(item.Type!==1){
              this.operationsDialogTitle = item.Name
              this.operationsDialogVisible = true;
              this.$nextTick(()=>{
                this.documentOperationsFun(item)
              })
            }
          }else if(btn.Type==='download'){
            //是否为附件（0否，1是）
            item.isattach= 0
            this.documentDownloadFun(item)
          }else if(btn.Type==='public'){
            this.documentShareAddPublicFun(item)
          }else if(btn.Type==='audit'){
            this.addRoleDialogVisible=true;
          }
          this.formData.actionType = btn.Type
      }
    },
    shareDept(){
      this.shareDialogVisible=false;
      this.addDeptsDialogVisible=true;    
    },
    shareUser(){
      this.shareDialogVisible=false;
      this.addRolesDialogVisible=true;
    },
    downloadAttach(data){
      data.isattach= 1
      this.documentDownloadFun(data)
    },
    documentViewFun(item){
      //downLoad(res,item)
      item.isdownload = 0;
      item.id = item.ID
      documentView(item)
    },
    documentDownloadFun(item,type){
      //downLoad(res,item)
      item.id = item.ID;
      if(type){
        item.isdownload = 0;
      }else{
        item.isdownload = 1;
      }

      documentDownload(item,type)
    },
    documentOperationsFun(item){
      documentOperations({id:item.ID}).then((res) => {
          if (res.Code === 200) {
            this.operationsTableData = res.Data
          }
          this.operationsOptions.loading=false;
      });
    },
    deleteAttach(item){
      this.$confirm('确定删除此文件吗？', '提示', {
        showClose:false,
        type: 'warning'
      }).then((res) => {
        documentAttachDelete(item).then((res) => {
          if (res.Code === 200) {
            this.refsh()
            this.$successMessage(res.Message);
          }
        });
      }).catch((res) => {
      });
      
    },
    documentShareAddPublicFun(){
      this.shareDialogVisible=false;
      let data = this.rightCurrent
      this.$confirm('确认公开此文件吗', '提示', {
          type: 'warning'
      }).then(() => {
          this.documentShareAddFun('public',data)
      }).catch((res) => {
      });
    },
    documentShareAddFun(type,data){
      let params = {}
      //是否公共   0否1是
      
      params.SourceName = this.rightCurrent.Name;
      params.ObjectID = this.rightCurrent.ID;
      params.ObjectType = this.rightCurrent.Type;
      if(type==='depts'){
        params.Users=[]
        params.Depts=data
        params.IsCommon = 0;
      }else if(type==='roles'){
        params.Users=data
        params.Depts=[]
       params.IsCommon = 0;
      }else if(type==='public'){
        params.Users=[]
        params.Depts=[]
        params.IsCommon = 1;
      }
      documentShareAdd(params).then((res) => {
          if (res.Code === 200) {
            this.refsh()
            this.addRolesDialogVisible=false;
            this.addDeptsDialogVisible=false;     
            this.addRolesDialogVisible=false;
            this.shareDialogVisible=false
            this.$successMessage(res.Message);
          }
      });
    },
    documentShareDeleteFun(item){
      this.$confirm('确定删除此文件吗？', '提示', {
        showClose:false,
        type: 'warning'
      }).then((res) => {
        documentShareDelete({ID:item.ID}).then((res) => {
          if (res.Code === 200) {
            this.refsh()
            this.$successMessage(res.Message);
          }
      });
      }).catch((res) => {
      });
      
    },
    getFileList: function(){
      this.fileList = this.$refs.fileUpload.getFileList();
    },
    diaLogSubmit() {
        this.$refs[this.bindRef].validate((valid) => {
        if (valid) {
            this.formData.Category = this.category;
            this.formData.AuditedStatus = this.auditedStatus;
            (this.formData.actionType==='edit'?(this.formData.FileExt?documentEdit:documentFolderEdit):documentFolderAdd)(this.formData).then((res) => {
            if (res.Code === 200) {
              this.refsh()
              this.$successMessage(res.Message);
              this.dialogVisible = false
            }
          });
        }
      });
    },
    uploadCloseCallback(){
      this.uploadVisiable = false;
    },
    upLoad(boolean,again) {
      this.isAttach = boolean?boolean:false;
      if(!this.isAttach){
        if(again){
          this.options.formData.docid = this.formData.ID
        }else{
          delete  this.options.formData.docid
        }
      }
      this.uploadVisiable = true;
    },
    createFolder() {
        this.formData = {};
        this.formData.ParentID = this.current.ID
        this.dialogVisible=true;
        this.dialogTitle = '添加文件夹'
        this.$nextTick(()=>{
              this.documentFolderTreeFun();
            })
    },
    loadData(param) {
      this.refsh()
    },
    documentDeleteFun(item){
      this.$confirm('确定删除此文件吗？', '提示', {
        showClose:false,
        type: 'warning'
      }).then((res) => {
          documentDelete(item).then((res) => {
            if (res.Code === 200) {
              //this.documentShareDeleteFun(item)
              this.refsh()
              this.$successMessage(res.Message);
            }
        });
      }).catch((res) => {
      });
      
    },
    documentFolderDeleteFun(item){
      this.$confirm('确定删除此文件夹吗？', '提示', {
        showClose:false,
        type: 'warning'
      }).then((res) => {
        documentFolderDelete({ID:item.ID,Category: this.category}).then((res) => {
            if (res.Code === 200) {
              this.refsh()
              this.$successMessage(res.Message);
            }
        });
      }).catch((res) => {
      });
      
    },
    documentFirstlevellistFun(){
      this.current = {};
      documentFirstlevellist({DeptID:this.currentTreeId,Category: this.category}).then((res) => {
          if (res.Code === 200) {
            this.documentData = res.Data
            this.documentData.map((item,index)=>{
              if(item.ID===this.rightCurrent.ID){
                this.attachTableData = item.AttachList?item.AttachList:[]
              }
            })
          }
      });
    },
    nodeClick(obj) {
      this.currentTreeId = obj.ID;
      this.$refs.documentMange.init();
      this.documentFirstlevellistFun();
    },
    documentFolderChildrenFun(item){
      this.current = item;
      documentFolderChildren({folderid:item.ID}).then((res) => {
          if (res.Code === 200) {
            this.documentData = res.Data
            this.documentData.map((item,index)=>{
              if(item.ID===this.rightCurrent.ID){
                this.attachTableData = item.AttachList?item.AttachList:[]
              }
            })
          }
      });
    },
    documentFolderTreeFun() {
      this.parentData = [{ children: [], label: "根目录", id: "" }];
      documentFolderTree({ category: this.category }).then((res) => {
        if (res.Code === 200 && res.Data) {
          this.parentData[0].children = res.Data;
          this.mapParentData(this.parentData[0].children)
        }
      });
    },
    mapParentData(row){
      if(row instanceof Array){
        row.forEach((item,index)=>{
          if(item.id===this.formData.ID){
            row.splice(index,1)
            this.mapParentData(item)
          }else{
            this.mapParentData(item)
          }
          
        })
      }else{
        if(row.children){
            this.mapParentData(row.children)
        }else{
        }
      }
    },
    setTreeWidth(value) {
      this.treeWidth = value;
    },
  },
};
</script>
<style scoped  lang="scss">
.icon{
  font-size: 12px !important;
}
.content {
  display: flex;
  flex-direction: column;
  &-top {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 5px;
    margin-bottom: 5px;
    border-bottom: 1px solid #dbdbdb;
    .search {
      width: 150px;
      display: inline-block;
    }
  }
  &-aside {
  }
  &-content {
    height: 100%;
    width: 100%;
    border-left: 1px solid #dbdbdb;
  }
  &-bottom {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: auto;
  }
}
>>> .button-group .icon {
  font-size: 12px !important;
}
.uploadAgain {
  margin-left: 110px;
}
</style>



// WEBPACK FOOTER //
// src/views/document/Document.vue